// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__xMt13","header":"PatientBlock_header__3_HGV","label":"PatientBlock_label__2cinO","option":"PatientBlock_option__3wruO"};